"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var client_1 = require("@apollo/client");
var rules_api_1 = require("@gamepark/rules-api");
var use_pusher_1 = require("@harelpls/use-pusher");
var moment_1 = __importDefault(require("moment"));
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var redux_1 = require("redux");
var AnimationsListenerCreator_1 = require("../animations/AnimationsListenerCreator");
var GameClientAPI_1 = __importDefault(require("../api/Client/GameClientAPI"));
var ConsoleTools_1 = __importDefault(require("../api/Local/ConsoleTools"));
var GameLocalAPI_1 = __importDefault(require("../api/Local/GameLocalAPI"));
var DatadogLogsInitializer_1 = require("../datadog/DatadogLogsInitializer");
var index_1 = require("../index");
var gameMiddleware_1 = __importDefault(require("../Store/gameMiddleware"));
var gameReducer_1 = __importDefault(require("../Store/gameReducer"));
var GameContext_1 = __importDefault(require("./GameContext"));
var GameProviderProps_1 = require("./GameProviderProps");
var apolloClient = new client_1.ApolloClient({
    link: client_1.ApolloLink.from([new client_1.HttpLink({ uri: index_1.PLATFORM_URI + ((_a = process.env.REACT_APP_GRAPHQL_ENDPOINT) !== null && _a !== void 0 ? _a : '/api/graphql'), fetch: fetch, credentials: 'include' })]),
    cache: new client_1.InMemoryCache({
        typePolicies: {
            ChatChannel: {
                keyFields: ['name'],
                fields: {
                    messages: {
                        keyArgs: false,
                        merge: function (existing, incoming) {
                            if (existing === void 0) { existing = []; }
                            if (incoming === void 0) { incoming = []; }
                            return __spreadArray(__spreadArray([], incoming), existing).sort(function (m1, m2) { return moment_1.default(m1.date).unix() - moment_1.default(m2.date).unix(); })
                                .filter(function (message, index, messages) { return index === 0 || message.id !== messages[index - 1].id; });
                        }
                    }
                }
            },
            Message: {
                keyFields: false
            }
        }
    })
});
function GameProvider(_a) {
    var _b, _c;
    var children = _a.children, props = __rest(_a, ["children"]);
    react_1.useEffect(DatadogLogsInitializer_1.initDatadogLogs, []);
    var RulesView = (GameProviderProps_1.isGameViewProviderProps(props) ? props.RulesView : props.Rules);
    var gameViewProps = __assign(__assign({}, props), { RulesView: RulesView });
    var store = react_1.useMemo(function () { return createGameStore(gameViewProps); }, [props, RulesView]);
    return (jsx_runtime_1.jsx(GameContext_1.default.Provider, __assign({ value: gameViewProps }, { children: jsx_runtime_1.jsx(client_1.ApolloProvider, __assign({ client: apolloClient }, { children: jsx_runtime_1.jsx(use_pusher_1.PusherProvider, __assign({ clientKey: (_b = process.env.REACT_APP_PUSHER_KEY) !== null && _b !== void 0 ? _b : '747557f1e8edf7fc2816', cluster: (_c = process.env.REACT_APP_PUSHER_CLUSTER) !== null && _c !== void 0 ? _c : 'eu' }, { children: jsx_runtime_1.jsx(react_redux_1.Provider, __assign({ store: store }, { children: children }), void 0) }), void 0) }), void 0) }), void 0));
}
exports.default = GameProvider;
function createGameStore(props) {
    var query = new URLSearchParams(window.location.search);
    var gameId = query.get('game');
    if (gameId) {
        return createRemoteApiStore(props, gameId);
    }
    return createLocalApiStore(props);
}
function createRemoteApiStore(_a, gameId) {
    var RulesView = _a.RulesView, animations = _a.animations, game = _a.game;
    var api = new GameClientAPI_1.default(gameId);
    var store = redux_1.createStore(gameReducer_1.default(game, RulesView, animations), redux_1.applyMiddleware(gameMiddleware_1.default(api)));
    store.subscribe(AnimationsListenerCreator_1.createAnimationsListener(store));
    api.init(store.dispatch);
    return store;
}
function createLocalApiStore(props) {
    var robot = props.dummy || createDummy(props.Rules);
    var api = new GameLocalAPI_1.default(props.game, props.Rules, props.RulesView, robot, props.optionsSpec, props.ai, props.tutorial);
    var store = redux_1.createStore(gameReducer_1.default(props.game, props.RulesView, props.animations), redux_1.applyMiddleware(gameMiddleware_1.default(api)));
    store.subscribe(AnimationsListenerCreator_1.createAnimationsListener(store));
    if (process.env.NODE_ENV === 'development') {
        window.game = ConsoleTools_1.default(api, store);
    }
    api.init(store.dispatch);
    return store;
}
function createDummy(Rules) {
    var dummy = new rules_api_1.Dummy(Rules);
    return function (state, playerId) { return dummy.getRandomMove(state, playerId); };
}
//# sourceMappingURL=GameProvider.js.map